import { BankTransactionType } from '@/services/types/TransactionData';

export const extractTransactionFilter = (transactionFilter: string[]) =>
  Array.from(
    new Set(
      transactionFilter.map((filter) => {
        const [transactionType] = filter.split('-');

        return transactionType;
      })
    )
  );

export const extractBankTransactionFilter = (transactionFilter: string[]): BankTransactionType[] =>
  transactionFilter
    .map((filter) => {
      const [, bankTransactionType] = filter.toUpperCase().split('-');

      return bankTransactionType == 'NULL' ? null : (bankTransactionType as BankTransactionType);
    })
    .filter((item) => item) as BankTransactionType[];
